export var IMAGE_SIZE = 24;
export var IMAGE_MODS = ["q_auto", "c_pad", "w_" + IMAGE_SIZE, "h_" + IMAGE_SIZE];
export var SEARCH_MESSAGES = [
    "blogSearch.categories.title",
    "blogSearch.results.title",
    "blogSearch.results.fullResults",
    "blogSearch.noResults",
];
//# sourceMappingURL=constants.js.map